import React from 'react'
import propTypes from 'prop-types'

import { Header } from './components/Header'
import { Card } from '@components/layout/Card'

import { LiabilitiesProvider } from './context'
import { Screens } from './Screens'

export const Liabilities = (props) => {
  return (
    <LiabilitiesProvider {...props}>
      <Card className='ui-card--asset'>
        <Header />
        <Screens />
      </Card>
    </LiabilitiesProvider>
  )
}

Liabilities.propTypes = {
  scenario: propTypes.shape({
    id: propTypes.number,
  }),
  liabilities: propTypes.arrayOf(propTypes.object).isRequired,
  crudActions: propTypes.object,
  tenant: propTypes.object.isRequired,
  supportedLiabilityTypes: propTypes.arrayOf(propTypes.string).isRequired,
  featureToggles: propTypes.object.isRequired,
}
